import { useState } from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import MenuItem from '@mui/material/MenuItem';
import Radio from '@mui/material/Radio';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import InputAdornment from '@mui/material/InputAdornment';
import AddIcon from '@mui/icons-material/Add';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

const FFToggleButtonGroup = styled(ToggleButtonGroup)(() => ({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'start',
    '& .MuiToggleButtonGroup-grouped': {
        flexWrap: 'wrap',
        margin: '4px 12px 4px 12px',
        border: 0,
        boxShadow: '0px 0px 10px #F2F2F2',
        borderRadius: 10,
        textTransform: 'none',
        '&.Mui-disabled': {
            border: 0,
            boxShadow: '0px 0px 10px #999',
            textTransform: 'none',
        },
        '&:not(:first-of-type)': {
            borderRadius: 10,
            margin: '4px 12px 4px 0px'
        },
        '&:first-of-type': {
            borderRadius: 10,
            margin: '4px 12px 4px 0px'
        },
    },
}));



export default function AddEnrollmentDetailsTab() {

    const [incident, setIncidentReported] = useState('');
    const handleChange = (event: SelectChangeEvent) => {
        setIncidentReported(event.target.value);
    };

    const [caseTypes, setCaseTypes] = useState(() => ['phone']);

    const handleCaseTypes = (
        event: React.MouseEvent<HTMLElement>,
        newCases: string[],
    ) => {
        if (newCases.length) {
            setCaseTypes(newCases);
        }
    };

    return (
        <Stack>
            <Stack direction="row"
                sx={{
                    alignItems: 'center',
                    mt: 2,
                    pl: 7
                }}
            >
                <Typography>
                    Enabled
                </Typography>
                <Switch color="secondary" checked={true} />

                <Radio size="small"
                    sx={{
                        ml: 4,
                        color: 'info.main',
                        '&.Mui-checked': {
                            color: 'info.main',
                        },
                    }}
                />
                <Typography>
                    Opt-Out
                </Typography>
            </Stack>

            <Stack direction="row"
                spacing={0}
                sx={{
                    alignItems: 'center',
                    mt: 2,
                    ml: 6,
                    mr: 6,
                    p: 2,
                    backgroundColor: 'grey.200'
                }}
            >
                <Radio size="small"
                    sx={{
                        color: 'info.main',
                        '&.Mui-checked': {
                            color: 'info.main',
                        },
                    }}
                />
                <Typography color="primary"
                    sx={{
                        marginLeft: 1,
                        paddingLeft: 0
                    }}
                >
                    Expiration Date
                </Typography>
                <TextField
                    sx={{
                        ml: 1,
                    }}
                    placeholder="10/15/2021"
                    InputProps={{
                        endAdornment: <InputAdornment position="start"><CalendarTodayIcon /></InputAdornment>,
                    }}
                />
                <Radio size="small"
                    sx={{
                        ml: 4,
                        color: 'info.main',
                        '&.Mui-checked': {
                            color: 'info.main',
                        },
                    }}
                />
                <Typography color="primary">
                    No Expiration Date
                </Typography>
            </Stack>

            <Stack direction="row"
                spacing={2}
                sx={{
                    alignItems: 'center',
                    mt: 2,
                    ml: 6,

                    mr: 6,
                    p: 2,
                }}
            >
                <TextField
                    sx={{
                        '& label': {
                            color: 'primary.main',
                        }
                    }}
                    label="Location"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    placeholder="Location"
                />

                <TextField
                    sx={{
                        '& label': {
                            color: 'primary.main',
                        }
                    }}
                    label="Loss Value"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    placeholder="$0"
                />

                <Select
                    value={incident}
                    onChange={handleChange}
                    displayEmpty={true}
                    inputProps={{ 'aria-label': 'Without label' }}
                >
                    <MenuItem disabled={true} value="">
                        Incident Reported
                    </MenuItem>
                    <MenuItem value="babyformula">Baby formula</MenuItem>
                    <MenuItem value="alcohol">Alcohol</MenuItem>
                    <MenuItem value="deli-meat">Deli/Meat</MenuItem>
                    <MenuItem value="electronics">Electronics</MenuItem>
                </Select>
            </Stack>

            <Stack direction="row"
                spacing={2}
                sx={{
                    alignItems: 'center',
                    mt: 2,
                    ml: 6,
                    mr: 6,
                    p: 2,
                }}
            >
                <Typography color="primary" sx={{ fontWeight: 'bold' }}>Case Type</Typography>
            </Stack>

            <Stack direction="row"
                spacing={2}
                sx={{
                    alignItems: 'flex-end',
                    p: 2,
                    justifyContent: 'space-between',
                    ml: 6,
                    mr: 6

                }}
            >
                <FFToggleButtonGroup
                    sx={{
                        width: '80%'
                    }}
                    color="primary"
                    value={caseTypes}
                    onChange={handleCaseTypes}>
                    <ToggleButton size="large" value="orc">ORC</ToggleButton>
                    <ToggleButton size="large" value="transient">Transient</ToggleButton>
                    <ToggleButton size="large" value="ios">Violent Offender</ToggleButton>
                    <ToggleButton size="large" value="fraud">Fraud</ToggleButton>
                    <ToggleButton size="large" value="lawenforcement">Law Enforcement</ToggleButton>
                    <ToggleButton size="large" value="armedrobbery">Armed Robbery</ToggleButton>
                    <ToggleButton size="large" value="serious">Serious/Heinous</ToggleButton>
                    <ToggleButton size="large" value="shoplifting">Shoplifting</ToggleButton>
                    <ToggleButton size="large" value="trafficking">Trafficking</ToggleButton>
                </FFToggleButtonGroup>
                <Box
                    sx={{
                        mb: 4
                    }}>
                    <Button
                        sx={{
                            mr: 10
                        }}
                        startIcon={<AddIcon />} size="large" color="secondary">New</Button
                    >
                </Box>
            </Stack>

            <Stack
                sx={{
                    mt: 2,
                    ml: 6,
                    mr: 6,
                    p: 2,
                }}
            >
                <Typography>
                    Narrative
                </Typography>
                <TextField
                    sx={{
                        mt: 1,
                        '& label': {
                            color: 'primary.main',
                        }
                    }}
                    multiline={true}
                    rows={4}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    placeholder="Narrative of person"
                />


            </Stack>
            <Box
                sx={{
                    ml: 8,
                    mr: 8,
                    textAlign: 'right'
                }}
            >
                <Button
                    variant="contained" color="secondary"
                    size="large"
                    sx={{
                        mt: 4
                    }}
                >Enroll</Button>
            </Box>
        </Stack>

    )
}
